import styled from 'styled-components';

import { Wrapper, Title } from '../../../../shared/ModalComponents';
import { Button } from '../../../../shared/FormStyles';
import { ModalButtonGroup } from '../StyledComponents';

const StyledParagraph = styled.p`
  margin: 0 0 24px;
  font-size: 14px;
  font-weight: 400;
  text-align: start;
`;

const DeleteTitle = styled(Title)`
  margin: 0 0 12px;
`;

const DeleteSegment = ({ onCancel, onConfirm, title }) => {
  return (
    <Wrapper>
      <DeleteTitle>{title}</DeleteTitle>
      <StyledParagraph>
        Are you sure you want to delete this population segment?
      </StyledParagraph>
      <ModalButtonGroup>
        <Button variant="tertiary" onClick={onCancel}>
          No
        </Button>
        <Button variant="containedBlue" ml="8px" onClick={onConfirm}>
          Yes
        </Button>
      </ModalButtonGroup>
    </Wrapper>
  );
};

export default DeleteSegment;
